import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Typography, Button, Paper, Grid } from '@mui/material';
import { obterDisciplina, excluirDisciplina } from '../../services/disciplinaService';

const DetalhesDisciplinaPage = () => {
  const [disciplina, setDisciplina] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDisciplina = async () => {
      try {
        const data = await obterDisciplina(id);
        setDisciplina(data);
      } catch (error) {
        console.error('Erro ao buscar detalhes da disciplina:', error);
        // TODO: Adicionar tratamento de erro e feedback ao usuário
      }
    };

    fetchDisciplina();
  }, [id]);

  const handleExcluir = async () => {
    if (window.confirm('Tem certeza que deseja excluir esta disciplina?')) {
      try {
        await excluirDisciplina(id);
        navigate('/disciplinas');
      } catch (error) {
        console.error('Erro ao excluir disciplina:', error);
        // TODO: Adicionar tratamento de erro e feedback ao usuário
      }
    }
  };

  if (!disciplina) {
    return <Typography>Carregando...</Typography>;
  }

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h4" gutterBottom>
        {disciplina.nome}
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography><strong>Descrição:</strong> {disciplina.descricao}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography><strong>Carga Horária:</strong> {disciplina.cargaHoraria} horas</Typography>
        </Grid>
      </Grid>
      <Button
        variant="contained"
        color="primary"
        onClick={() => navigate(`/disciplinas/editar/${id}`)}
        sx={{ mt: 2, mr: 1 }}
      >
        Editar
      </Button>
      <Button
        variant="contained"
        color="error"
        onClick={handleExcluir}
        sx={{ mt: 2 }}
      >
        Excluir
      </Button>
    </Paper>
  );
};

export default DetalhesDisciplinaPage;